// src/components/pos/POSModals.js
import { useState } from 'react'
import { supabase } from '../../supabase'
import { RETURN_TYPES } from './pos.constants'

function Overlay({ onClose, children, wide }) {
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:'16px' }}>
      <div className="pos-modal-in" style={{ background:'var(--bg-card)', borderRadius:'var(--radius-lg)', width:'100%', maxWidth: wide ? '640px' : '420px', maxHeight:'90vh', overflowY:'auto', fontFamily:'var(--font-ui)', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        {children}
      </div>
    </div>
  )
}

function ModalHeader({ title, onClose }) {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 18px', borderBottom:'1px solid var(--border)' }}>
      <div style={{ fontSize:'14px', fontWeight:700, color:'var(--text-primary)' }}>{title}</div>
      <button onClick={onClose} style={{ width:'28px', height:'28px', borderRadius:'50%', background:'var(--bg-muted)', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-muted)', fontSize:'16px' }}>×</button>
    </div>
  )
}

const inp = { width:'100%', border:'1px solid var(--border)', borderRadius:'var(--radius-md)', padding:'8px 12px', fontSize:'13px', outline:'none', background:'var(--bg-card)', color:'var(--text-primary)', fontFamily:'var(--font-ui)', boxSizing:'border-box', transition:'border-color 0.15s' }
const inpF = e => e.target.style.borderColor = 'var(--primary)'
const inpB = e => e.target.style.borderColor = 'var(--border)'

// ── NUMPAD MODAL ──────────────────────────────────────────────
function NumpadModal({ target, value, setValue, onConfirm, onClose, sym }) {
  const handleDigit = d => setValue(v => v === '0' ? d : v + d)
  const handleDot   = () => setValue(v => v.includes('.') ? v : v + '.')
  const handleBack  = () => setValue(v => v.slice(0, -1) || '0')
  const handleClear = () => setValue('0')

  return (
    <Overlay onClose={onClose}>
      <ModalHeader title={target?.field === 'qty' ? 'Set Quantity' : 'Set Price'} onClose={onClose} />
      <div style={{ padding:'20px' }}>
        {/* Display */}
        <div style={{ textAlign:'center', padding:'16px', borderRadius:'var(--radius-md)', background:'var(--bg-muted)', marginBottom:'16px' }}>
          <div style={{ fontSize:'11px', color:'var(--text-muted)', marginBottom:'4px', textTransform:'uppercase', letterSpacing:'0.06em' }}>
            {target?.field === 'qty' ? 'Quantity' : `Price (${sym})`}
          </div>
          <div style={{ fontSize:'32px', fontWeight:800, color:'var(--primary)', letterSpacing:'-1px' }}>{value || '0'}</div>
        </div>

        {/* Numpad grid */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px', marginBottom:'10px' }}>
          {['1','2','3','4','5','6','7','8','9','.','0','⌫'].map(d => (
            <button key={d} onClick={() => d === '⌫' ? handleBack() : d === '.' ? handleDot() : handleDigit(d)}
              style={{ padding:'18px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'18px', fontWeight:600, color:'var(--text-primary)', cursor:'pointer', transition:'background 0.1s' }}
              onMouseEnter={e => e.currentTarget.style.background='var(--bg-muted)'}
              onMouseLeave={e => e.currentTarget.style.background='var(--bg-card)'}>
              {d}
            </button>
          ))}
        </div>

        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={handleClear} style={{ flex:1, padding:'12px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Clear</button>
          <button onClick={() => onConfirm(value)} style={{ flex:2, padding:'12px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', fontSize:'14px', fontWeight:700, color:'#fff', cursor:'pointer' }}>Confirm</button>
        </div>
      </div>
    </Overlay>
  )
}

// ── VARIANT PICKER MODAL ──────────────────────────────────────
function VariantModal({ variantPicker, pickerQty, setPickerQty, pickerNote, setPickerNote, pickerWeight, setPickerWeight, onConfirm, onClose, sym, isJewellery, goldRates }) {
  const { product, variants, needsWeightInput } = variantPicker || {}
  const [selected, setSelected] = useState('')

  if (!product) return null

  const handleAdd = () => {
    onConfirm(selected)
    onClose()
  }

  return (
    <Overlay onClose={onClose}>
      <ModalHeader title={product.name} onClose={onClose} />
      <div style={{ padding:'16px' }}>

        {/* Variants */}
        {variants?.length > 0 && (
          <div>
            <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'8px' }}>Select variant</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'7px', marginBottom:'14px' }}>
              {variants.map(v => (
                <button key={v.id} onClick={() => !v.stock === 0 && setSelected(v.variant_name)}
                  disabled={v.stock === 0}
                  style={{ padding:'9px 14px', borderRadius:'var(--radius-md)', border:'2px solid', borderColor: selected === v.variant_name ? 'var(--primary)' : v.stock === 0 ? 'var(--border)' : 'var(--border)', background: selected === v.variant_name ? 'var(--primary-light)' : v.stock === 0 ? 'var(--bg-muted)' : 'var(--bg-card)', cursor: v.stock === 0 ? 'not-allowed' : 'pointer', opacity: v.stock === 0 ? 0.5 : 1 }}>
                  <div style={{ fontSize:'13px', fontWeight:700, color: selected === v.variant_name ? 'var(--primary)' : 'var(--text-primary)' }}>{v.variant_name}</div>
                  <div style={{ fontSize:'11px', color: v.stock === 0 ? 'var(--error)' : v.stock <= 5 ? 'var(--warning)' : 'var(--success)', marginTop:'2px' }}>
                    {v.stock === 0 ? 'Out of stock' : `${v.stock} left`}
                  </div>
                  {v.sell_price && Number(v.sell_price) !== Number(product.sell_price) && (
                    <div style={{ fontSize:'11.5px', fontWeight:700, color:'var(--primary)', marginTop:'2px' }}>{sym}{Number(v.sell_price).toLocaleString()}</div>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Weight input (jewellery or weight mode) */}
        {needsWeightInput && (
          <div style={{ marginBottom:'14px' }}>
            <label style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em', display:'block', marginBottom:'6px' }}>Weight (grams)</label>
            <input type="number" value={pickerWeight} onChange={e => setPickerWeight(e.target.value)}
              placeholder="0.000" step="0.001" style={inp} onFocus={inpF} onBlur={inpB} autoFocus />
            {isJewellery && product.gold_karat && goldRates && pickerWeight && (
              <div style={{ marginTop:'6px', fontSize:'12px', color:'var(--text-muted)', padding:'8px', borderRadius:'var(--radius-sm)', background:'var(--bg-muted)' }}>
                {product.gold_karat} · {pickerWeight}g — estimated price will be calculated at checkout
              </div>
            )}
          </div>
        )}

        {/* Qty */}
        <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'14px' }}>
          <span style={{ fontSize:'12px', fontWeight:600, color:'var(--text-muted)', flexShrink:0 }}>Quantity</span>
          <button onClick={() => setPickerQty(q => Math.max(1, q - 1))} style={{ width:'32px', height:'32px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-primary)' }}>−</button>
          <span style={{ fontSize:'16px', fontWeight:700, minWidth:'32px', textAlign:'center', color:'var(--text-primary)' }}>{pickerQty}</span>
          <button onClick={() => setPickerQty(q => q + 1)} style={{ width:'32px', height:'32px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'18px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-primary)' }}>+</button>
        </div>

        {/* Note */}
        <div style={{ marginBottom:'16px' }}>
          <input value={pickerNote} onChange={e => setPickerNote(e.target.value)} placeholder="Note (optional)" style={{ ...inp, fontSize:'12px' }} onFocus={inpF} onBlur={inpB} />
        </div>

        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={onClose} style={{ flex:1, padding:'11px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Cancel</button>
          <button onClick={handleAdd} disabled={variants?.length > 0 && !selected} style={{ flex:2, padding:'11px', borderRadius:'var(--radius-md)', border:'none', background: (variants?.length > 0 && !selected) ? 'var(--border)' : 'var(--primary)', fontSize:'13px', fontWeight:700, color:'#fff', cursor: (variants?.length > 0 && !selected) ? 'not-allowed' : 'pointer' }}>
            Add to cart
          </button>
        </div>
      </div>
    </Overlay>
  )
}

// ── RECEIPT MODAL ─────────────────────────────────────────────
function ReceiptModal({ order, seller, sym, onClose }) {
  if (!order) return null
  const dateStr = new Date(order.created_at || new Date()).toLocaleString('en-BD', { day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })
  const portalUrl = `https://app.pageconnect.io/track/${order.order_code}`

  return (
    <Overlay onClose={onClose}>
      <div style={{ background:'var(--primary)', padding:'14px 18px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <span style={{ color:'#fff', fontSize:'14px', fontWeight:700 }}>Receipt</span>
        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={() => window.print()} style={{ padding:'5px 12px', borderRadius:'var(--radius-sm)', background:'rgba(255,255,255,0.15)', border:'1px solid rgba(255,255,255,0.25)', color:'#fff', fontSize:'12px', fontWeight:600, cursor:'pointer' }}>Print</button>
          <button onClick={onClose} style={{ padding:'5px 12px', borderRadius:'var(--radius-sm)', background:'rgba(255,255,255,0.1)', border:'none', color:'#fff', fontSize:'12px', fontWeight:600, cursor:'pointer' }}>New sale</button>
        </div>
      </div>

      <div style={{ padding:'18px' }}>
        {/* Amount hero */}
        <div style={{ textAlign:'center', padding:'18px', borderRadius:'var(--radius-lg)', border:'2px dashed var(--border)', marginBottom:'14px' }}>
          <div style={{ fontSize:'11px', color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'4px' }}>Total Charged</div>
          <div style={{ fontSize:'30px', fontWeight:800, color:'var(--text-primary)', marginBottom:'4px', letterSpacing:'-1px' }}>{sym}{Number(order.total_amount || 0).toLocaleString()}</div>
          <div style={{ fontSize:'12.5px', fontWeight:700, color:'var(--primary)', fontFamily:'monospace' }}>{order.order_code}</div>
          <div style={{ fontSize:'12px', color:'var(--text-muted)', marginTop:'4px' }}>{dateStr}</div>
          {/* Payment method */}
          <div style={{ marginTop:'8px', display:'flex', gap:'6px', justifyContent:'center', flexWrap:'wrap' }}>
            <span style={{ fontSize:'11.5px', fontWeight:600, color:'var(--text-primary)', background:'var(--bg-muted)', padding:'3px 10px', borderRadius:'var(--radius-full)' }}>{order.paymentMethod}</span>
            {order.splitEnabled && order.paymentMethod2 && <span style={{ fontSize:'11.5px', fontWeight:600, color:'var(--text-primary)', background:'var(--bg-muted)', padding:'3px 10px', borderRadius:'var(--radius-full)' }}>+ {order.paymentMethod2}</span>}
          </div>
        </div>

        {/* Items */}
        <div style={{ background:'var(--bg-muted)', borderRadius:'var(--radius-md)', padding:'10px 12px', marginBottom:'12px' }}>
          {(order.items || []).map((item, i) => (
            <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', padding:'5px 0', borderBottom: i < order.items.length - 1 ? '1px solid var(--border)' : 'none', gap:'8px' }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:'12.5px', fontWeight:600, color:'var(--text-primary)' }}>{item.name}</div>
                {item.gold_karat && <div style={{ fontSize:'11px', color:'var(--warning)' }}>{item.gold_karat}{item.gold_weight ? ` · ${item.gold_weight}g` : ''}</div>}
                {item.hallmark_number && <div style={{ fontSize:'11px', color:'var(--text-muted)' }}>Hallmark: {item.hallmark_number}</div>}
              </div>
              <div style={{ textAlign:'right', flexShrink:0 }}>
                <div style={{ fontSize:'12px', color:'var(--text-muted)' }}>×{item.quantity}</div>
                <div style={{ fontSize:'12.5px', fontWeight:700, color:'var(--text-primary)' }}>{sym}{(item.unit_price * item.quantity).toLocaleString()}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Breakdown */}
        <div style={{ display:'flex', flexDirection:'column', gap:'5px', padding:'0 2px', marginBottom:'14px' }}>
          {order.subtotal !== order.total_amount && <ReceiptRow label="Subtotal" value={`${sym}${order.subtotal?.toLocaleString()}`} />}
          {order.discountAmount > 0 && <ReceiptRow label="Discount" value={`−${sym}${order.discountAmount?.toLocaleString()}`} color="var(--error)" />}
          {order.taxAmount > 0 && <ReceiptRow label={order.tax_type || 'VAT'} value={`+${sym}${order.taxAmount?.toLocaleString()}`} color="var(--primary)" />}
          {order.oldGoldDeduction > 0 && <ReceiptRow label="Old gold exchange" value={`−${sym}${order.oldGoldDeduction?.toLocaleString()}`} color="var(--warning)" />}
          {order.storeCreditUsed > 0 && <ReceiptRow label="Store credit" value={`−${sym}${order.storeCreditUsed?.toLocaleString()}`} color="var(--success)" />}
          {order.splitEnabled && <><ReceiptRow label={`Paid (${order.paymentMethod})`} value={`${sym}${order.amountPaid?.toLocaleString()}`} /><ReceiptRow label={`Paid (${order.paymentMethod2})`} value={`${sym}${order.amountPaid2?.toLocaleString()}`} /></>}
          {order.change > 0 && <ReceiptRow label="Change" value={`${sym}${order.change?.toLocaleString()}`} color="var(--success)" />}
          {order.balanceDue > 0 && <ReceiptRow label="Balance due" value={`${sym}${order.balanceDue?.toLocaleString()}`} color="var(--error)" bold />}
        </div>

        {/* Staff / branch */}
        {(order.staff_name || order.branch_name) && (
          <div style={{ background:'var(--bg-muted)', borderRadius:'var(--radius-sm)', padding:'8px 12px', fontSize:'12px', color:'var(--text-muted)', marginBottom:'12px' }}>
            {order.branch_name && <div>Branch: <strong style={{ color:'var(--text-primary)' }}>{order.branch_name}</strong></div>}
            {order.staff_name  && <div>Served by: <strong style={{ color:'var(--text-primary)' }}>{order.staff_name}</strong></div>}
          </div>
        )}

        {/* Customer portal link */}
        <div style={{ background:'var(--primary-light)', borderRadius:'var(--radius-md)', padding:'10px 14px', fontSize:'12px', color:'var(--primary)', textAlign:'center', border:'1px solid var(--primary-border)' }}>
          Customer can download receipt at:<br />
          <a href={portalUrl} target="_blank" rel="noopener noreferrer" style={{ color:'var(--primary)', fontWeight:700, fontSize:'11.5px', wordBreak:'break-all' }}>{portalUrl}</a>
        </div>
      </div>

      {/* Print CSS */}
      <style>{`@media print { body > *:not(.pos-print) { display: none; } }`}</style>
    </Overlay>
  )
}

function ReceiptRow({ label, value, color, bold }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <span style={{ fontSize:'12px', color:'var(--text-muted)' }}>{label}</span>
      <span style={{ fontSize:'12.5px', fontWeight: bold ? 700 : 600, color: color || 'var(--text-primary)' }}>{value}</span>
    </div>
  )
}

// ── RETURN / REPLACE / EXCHANGE MODAL ────────────────────────
function ReturnModal({ sellerId, sym, onReturnComplete, onClose }) {
  const [step, setStep]           = useState(1) // 1=find order, 2=select items, 3=resolution, 4=confirm
  const [orderCode, setOrderCode] = useState('')
  const [foundOrder, setFoundOrder] = useState(null)
  const [searching, setSearching] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [returnType, setReturnType] = useState('return')
  const [refundMethod, setRefundMethod] = useState('Cash')
  const [exchangeProduct, setExchangeProduct] = useState('')
  const [exchangePrice, setExchangePrice] = useState('')
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState('')

  const searchOrder = async () => {
    if (!orderCode.trim()) return
    setSearching(true); setError('')
    const { data } = await supabase.from('orders').select('*').eq('seller_id', sellerId).eq('order_code', orderCode.trim().toUpperCase()).single()
    setSearching(false)
    if (data) { setFoundOrder(data); setStep(2) }
    else setError('Order not found. Check the order code and try again.')
  }

  const toggleItem = (item) => {
    setSelectedItems(prev => {
      const exists = prev.find(i => i.name === item.name)
      if (exists) return prev.filter(i => i.name !== item.name)
      return [...prev, { ...item, returnQty: item.quantity }]
    })
  }

  const updateReturnQty = (name, qty) => {
    setSelectedItems(prev => prev.map(i => i.name === name ? { ...i, returnQty: Math.min(Math.max(1, qty), i.quantity) } : i))
  }

  const totalRefund = selectedItems.reduce((s, i) => s + (i.unit_price * i.returnQty), 0)
  const exchangeDiff = returnType === 'exchange' ? (Number(exchangePrice) - totalRefund) : 0

  const handleProcess = async () => {
    if (selectedItems.length === 0) return
    setProcessing(true)

    const orderCode2 = `RTN-${Date.now().toString(36).toUpperCase()}`

    // Restock returned items
    for (const item of selectedItems) {
      if (item.product_id) {
        const { data: prod } = await supabase.from('products').select('stock').eq('id', item.product_id).single()
        if (prod) {
          await supabase.from('products').update({ stock: (prod.stock || 0) + item.returnQty }).eq('id', item.product_id)
          await supabase.from('stock_log').insert({ product_id: item.product_id, action: 'returned', quantity: item.returnQty, note: `Return of ${foundOrder.order_code}`, done_by: 'POS' })
        }
      }
    }

    // Create return record
    await supabase.from('orders').insert({
      seller_id: sellerId, order_code: orderCode2,
      product_name: selectedItems.map(i => i.name).join(', '),
      product_id: foundOrder.product_id,
      quantity: selectedItems.reduce((s, i) => s + i.returnQty, 0),
      unit_price: foundOrder.unit_price,
      total_amount: returnType === 'exchange' ? Math.max(0, exchangeDiff) : 0,
      is_return: true, return_of: foundOrder.order_code,
      return_type: returnType,
      return_items: JSON.stringify(selectedItems),
      refund_amount: returnType !== 'exchange' ? totalRefund : (exchangeDiff < 0 ? Math.abs(exchangeDiff) : 0),
      refund_method: returnType !== 'exchange' ? refundMethod : (exchangeDiff < 0 ? 'Cash' : null),
      payment_method: returnType === 'exchange' && exchangeDiff > 0 ? 'Cash' : null,
      payment_status: 'Paid in full', order_source: 'Walk-in / POS',
      status: 'return',
    })

    setProcessing(false)
    onReturnComplete()
  }

  return (
    <Overlay onClose={onClose} wide>
      <ModalHeader title="Return / Replace / Exchange" onClose={onClose} />
      <div style={{ padding:'16px' }}>

        {/* Step indicators */}
        <div style={{ display:'flex', gap:'6px', marginBottom:'20px' }}>
          {['Find Order', 'Select Items', 'Resolution', 'Confirm'].map((s, i) => (
            <div key={i} style={{ flex:1, padding:'6px', borderRadius:'var(--radius-sm)', background: step > i + 1 ? 'var(--success)' : step === i + 1 ? 'var(--primary)' : 'var(--bg-muted)', textAlign:'center', fontSize:'10.5px', fontWeight:700, color: step >= i + 1 ? '#fff' : 'var(--text-muted)' }}>
              {s}
            </div>
          ))}
        </div>

        {/* Step 1: Find order */}
        {step === 1 && (
          <div>
            <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'8px' }}>Enter order code</label>
            <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
              <input value={orderCode} onChange={e => setOrderCode(e.target.value.toUpperCase())}
                onKeyDown={e => e.key === 'Enter' && searchOrder()}
                placeholder="e.g. POS-KX3F9A" style={{ ...inp, flex:1, fontFamily:'monospace', fontSize:'14px' }} onFocus={inpF} onBlur={inpB} autoFocus />
              <button onClick={searchOrder} disabled={searching || !orderCode}
                style={{ padding:'8px 16px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>
                {searching ? '...' : 'Find'}
              </button>
            </div>
            {error && <div style={{ color:'var(--error)', fontSize:'12.5px', padding:'8px 12px', background:'#FEF2F2', borderRadius:'var(--radius-sm)' }}>{error}</div>}
          </div>
        )}

        {/* Step 2: Select items */}
        {step === 2 && foundOrder && (
          <div>
            <div style={{ padding:'10px 12px', borderRadius:'var(--radius-md)', background:'var(--bg-muted)', marginBottom:'14px', fontSize:'12px', color:'var(--text-muted)' }}>
              Order: <strong style={{ color:'var(--text-primary)' }}>{foundOrder.order_code}</strong> ·
              {new Date(foundOrder.created_at).toLocaleDateString('en-BD')} · {sym}{Number(foundOrder.total_amount).toLocaleString()}
            </div>

            <div style={{ marginBottom:'14px' }}>
              <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'8px' }}>Select items to return</div>
              {[{ name: foundOrder.product_name, unit_price: foundOrder.unit_price, quantity: foundOrder.quantity, product_id: foundOrder.product_id }].map((item, i) => {
                const sel = selectedItems.find(s => s.name === item.name)
                return (
                  <div key={i} onClick={() => toggleItem(item)}
                    style={{ padding:'10px 12px', borderRadius:'var(--radius-md)', border:'2px solid', borderColor: sel ? 'var(--primary)' : 'var(--border)', background: sel ? 'var(--primary-light)' : 'var(--bg-card)', marginBottom:'7px', cursor:'pointer', display:'flex', alignItems:'center', gap:'10px' }}>
                    <input type="checkbox" checked={!!sel} readOnly style={{ cursor:'pointer' }} />
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:'13px', fontWeight:600, color:'var(--text-primary)' }}>{item.name}</div>
                      <div style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>Qty: {item.quantity} · {sym}{item.unit_price}/unit</div>
                    </div>
                    {sel && (
                      <div style={{ display:'flex', alignItems:'center', gap:'6px' }} onClick={e => e.stopPropagation()}>
                        <span style={{ fontSize:'11.5px', color:'var(--text-muted)' }}>Return qty:</span>
                        <input type="number" value={sel.returnQty} onChange={e => updateReturnQty(item.name, Number(e.target.value))}
                          style={{ width:'50px', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', padding:'4px 6px', fontSize:'13px', fontWeight:700, textAlign:'center', outline:'none' }}
                          min={1} max={item.quantity} />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>

            <button onClick={() => selectedItems.length > 0 && setStep(3)} disabled={selectedItems.length === 0}
              style={{ width:'100%', padding:'12px', borderRadius:'var(--radius-md)', border:'none', background: selectedItems.length === 0 ? 'var(--border)' : 'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor: selectedItems.length === 0 ? 'not-allowed' : 'pointer' }}>
              Continue → ({selectedItems.length} item{selectedItems.length !== 1 ? 's' : ''} selected)
            </button>
          </div>
        )}

        {/* Step 3: Resolution type */}
        {step === 3 && (
          <div>
            <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'10px' }}>Resolution type</div>
            <div style={{ display:'flex', flexDirection:'column', gap:'8px', marginBottom:'16px' }}>
              {Object.values(RETURN_TYPES).map(rt => (
                <button key={rt.label} onClick={() => setReturnType(rt.label.toLowerCase())}
                  style={{ padding:'12px 14px', borderRadius:'var(--radius-md)', border:'2px solid', borderColor: returnType === rt.label.toLowerCase() ? 'var(--primary)' : 'var(--border)', background: returnType === rt.label.toLowerCase() ? 'var(--primary-light)' : 'var(--bg-card)', textAlign:'left', cursor:'pointer' }}>
                  <div style={{ fontSize:'13px', fontWeight:700, color: returnType === rt.label.toLowerCase() ? 'var(--primary)' : 'var(--text-primary)' }}>{rt.label}</div>
                  <div style={{ fontSize:'11.5px', color:'var(--text-muted)', marginTop:'2px' }}>{rt.desc}</div>
                </button>
              ))}
            </div>

            {/* Return: refund method */}
            {returnType === 'return' && (
              <div style={{ marginBottom:'12px' }}>
                <label style={{ fontSize:'11.5px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'6px' }}>Refund method</label>
                <div style={{ display:'flex', gap:'6px' }}>
                  {['Cash', 'bKash', 'Nagad', 'Card'].map(m => (
                    <button key={m} onClick={() => setRefundMethod(m)}
                      style={{ flex:1, padding:'8px', borderRadius:'var(--radius-sm)', border:'1.5px solid', borderColor: refundMethod === m ? 'var(--primary)' : 'var(--border)', background: refundMethod === m ? 'var(--primary-light)' : 'var(--bg-card)', fontSize:'12px', fontWeight:600, color: refundMethod === m ? 'var(--primary)' : 'var(--text-muted)', cursor:'pointer' }}>
                      {m}
                    </button>
                  ))}
                </div>
                <div style={{ marginTop:'10px', padding:'10px', borderRadius:'var(--radius-sm)', background:'#FEF2F2', border:'1px solid #FECACA', fontSize:'12.5px', color:'var(--error)', fontWeight:600 }}>
                  Refund: {sym}{totalRefund.toLocaleString()} via {refundMethod}
                </div>
              </div>
            )}

            {/* Exchange: new item price */}
            {returnType === 'exchange' && (
              <div style={{ marginBottom:'12px' }}>
                <div style={{ display:'flex', flexDirection:'column', gap:'7px' }}>
                  <div>
                    <label style={{ fontSize:'11.5px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'4px' }}>New item name</label>
                    <input value={exchangeProduct} onChange={e => setExchangeProduct(e.target.value)} placeholder="Enter product name" style={inp} onFocus={inpF} onBlur={inpB} />
                  </div>
                  <div>
                    <label style={{ fontSize:'11.5px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'4px' }}>New item price ({sym})</label>
                    <input type="number" value={exchangePrice} onChange={e => setExchangePrice(e.target.value)} placeholder="0" style={inp} onFocus={inpF} onBlur={inpB} />
                  </div>
                </div>
                {exchangePrice && (
                  <div style={{ marginTop:'10px', padding:'10px', borderRadius:'var(--radius-sm)', background: exchangeDiff > 0 ? 'var(--primary-light)' : '#F0FDF4', border:'1px solid', borderColor: exchangeDiff > 0 ? 'var(--primary-border)' : '#BBF7D0', fontSize:'12.5px', fontWeight:600, color: exchangeDiff > 0 ? 'var(--primary)' : 'var(--success)' }}>
                    {exchangeDiff > 0 ? `Customer pays: ${sym}${exchangeDiff.toLocaleString()} extra` : `Refund to customer: ${sym}${Math.abs(exchangeDiff).toLocaleString()}`}
                  </div>
                )}
              </div>
            )}

            <button onClick={() => setStep(4)}
              style={{ width:'100%', padding:'12px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>
              Review & Confirm →
            </button>
          </div>
        )}

        {/* Step 4: Confirm */}
        {step === 4 && (
          <div>
            <div style={{ padding:'14px', borderRadius:'var(--radius-lg)', background:'var(--bg-muted)', marginBottom:'16px' }}>
              <div style={{ fontSize:'12px', fontWeight:700, color:'var(--text-primary)', marginBottom:'8px', textTransform:'uppercase', letterSpacing:'0.06em' }}>Summary</div>
              <div style={{ fontSize:'12.5px', color:'var(--text-muted)', lineHeight:1.8 }}>
                <div>Type: <strong style={{ color:'var(--text-primary)' }}>{returnType.charAt(0).toUpperCase() + returnType.slice(1)}</strong></div>
                <div>Items: <strong style={{ color:'var(--text-primary)' }}>{selectedItems.map(i => `${i.name} ×${i.returnQty}`).join(', ')}</strong></div>
                {returnType === 'return' && <div>Refund: <strong style={{ color:'var(--error)' }}>{sym}{totalRefund.toLocaleString()} via {refundMethod}</strong></div>}
                {returnType === 'exchange' && <div>Exchange diff: <strong style={{ color: exchangeDiff > 0 ? 'var(--primary)' : 'var(--success)' }}>{exchangeDiff > 0 ? `Customer pays ${sym}${exchangeDiff.toLocaleString()}` : `Refund ${sym}${Math.abs(exchangeDiff).toLocaleString()}`}</strong></div>}
              </div>
            </div>

            <div style={{ display:'flex', gap:'8px' }}>
              <button onClick={() => setStep(3)} style={{ flex:1, padding:'12px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>← Back</button>
              <button onClick={handleProcess} disabled={processing}
                style={{ flex:2, padding:'12px', borderRadius:'var(--radius-md)', border:'none', background:'var(--error)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer', opacity: processing ? 0.7 : 1 }}>
                {processing ? 'Processing...' : 'Process ' + returnType.charAt(0).toUpperCase() + returnType.slice(1)}
              </button>
            </div>
          </div>
        )}
      </div>
    </Overlay>
  )
}

// ── VOID MODAL ────────────────────────────────────────────────
function VoidModal({ sellerId, staffSession, sym, onVoidComplete, onClose }) {
  const [orderCode, setOrderCode] = useState('')
  const [foundOrder, setFoundOrder] = useState(null)
  const [reason, setReason] = useState('')
  const [searching, setSearching] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState('')

  const searchOrder = async () => {
    setSearching(true); setError('')
    const { data } = await supabase.from('orders').select('*').eq('seller_id', sellerId).eq('order_code', orderCode.trim().toUpperCase()).is('voided_at', null).single()
    setSearching(false)
    if (data) setFoundOrder(data)
    else setError('Order not found or already voided.')
  }

  const handleVoid = async () => {
    if (!foundOrder || !reason.trim()) return
    setProcessing(true)
    await supabase.from('orders').update({ voided_at: new Date().toISOString(), void_reason: reason, voided_by: staffSession?.name || 'Seller' }).eq('id', foundOrder.id)
    // Restock
    if (foundOrder.product_id) {
      const { data: prod } = await supabase.from('products').select('stock').eq('id', foundOrder.product_id).single()
      if (prod) await supabase.from('products').update({ stock: (prod.stock || 0) + (foundOrder.quantity || 1) }).eq('id', foundOrder.product_id)
    }
    setProcessing(false)
    onVoidComplete()
  }

  return (
    <Overlay onClose={onClose}>
      <ModalHeader title="Void Order" onClose={onClose} />
      <div style={{ padding:'16px' }}>
        <div style={{ padding:'10px 12px', borderRadius:'var(--radius-sm)', background:'#FEF2F2', border:'1px solid #FECACA', fontSize:'12.5px', color:'var(--error)', marginBottom:'16px', display:'flex', gap:'8px', alignItems:'flex-start' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--error)" strokeWidth="2" strokeLinecap="round" style={{ flexShrink:0, marginTop:'1px' }}><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"/></svg>
          Voiding is permanent. Stock will be restocked automatically.
        </div>

        <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
          <input value={orderCode} onChange={e => setOrderCode(e.target.value.toUpperCase())}
            onKeyDown={e => e.key === 'Enter' && searchOrder()}
            placeholder="Order code e.g. POS-KX3F9A" style={{ ...inp, flex:1, fontFamily:'monospace' }} onFocus={inpF} onBlur={inpB} autoFocus />
          <button onClick={searchOrder} disabled={searching || !orderCode} style={{ padding:'8px 14px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>
            {searching ? '...' : 'Find'}
          </button>
        </div>

        {error && <div style={{ color:'var(--error)', fontSize:'12.5px', marginBottom:'10px' }}>{error}</div>}

        {foundOrder && (
          <div>
            <div style={{ padding:'10px 12px', borderRadius:'var(--radius-md)', background:'var(--bg-muted)', marginBottom:'12px', fontSize:'12px', color:'var(--text-muted)' }}>
              <strong style={{ color:'var(--text-primary)' }}>{foundOrder.order_code}</strong> · {foundOrder.product_name} ·
              {sym}{Number(foundOrder.total_amount).toLocaleString()} · {new Date(foundOrder.created_at).toLocaleDateString('en-BD')}
            </div>
            <div style={{ marginBottom:'12px' }}>
              <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'6px' }}>Reason for void *</label>
              <input value={reason} onChange={e => setReason(e.target.value)} placeholder="e.g. Customer cancelled, Duplicate order..." style={inp} onFocus={inpF} onBlur={inpB} />
            </div>
            <button onClick={handleVoid} disabled={processing || !reason.trim()}
              style={{ width:'100%', padding:'12px', borderRadius:'var(--radius-md)', border:'none', background: reason ? 'var(--error)' : 'var(--border)', color:'#fff', fontSize:'13px', fontWeight:700, cursor: reason ? 'pointer' : 'not-allowed', opacity: processing ? 0.7 : 1 }}>
              {processing ? 'Voiding...' : 'Confirm Void'}
            </button>
          </div>
        )}
      </div>
    </Overlay>
  )
}

// ── SHIFT CLOSE / END OF DAY MODAL ───────────────────────────
function ShiftModal({ todayStats, sym, options, onShiftComplete, onClose }) {
  const [cashCounted, setCashCounted] = useState('')
  const [notes, setNotes] = useState('')
  const cashVariance = cashCounted ? Number(cashCounted) - (todayStats.cashSales || todayStats.sales) : null

  return (
    <Overlay onClose={onClose} wide>
      <ModalHeader title="End of Day / Shift Close" onClose={onClose} />
      <div style={{ padding:'16px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'10px', marginBottom:'16px' }}>
          {[
            { label:'Total Sales',   value:`${sym}${todayStats.sales.toLocaleString()}`,   color:'var(--primary)' },
            { label:'Orders',        value:todayStats.orders,                               color:'var(--text-primary)' },
            { label:'Returns',       value:todayStats.returns,                              color:'var(--warning)' },
            { label:'Voids',         value:todayStats.voids,                               color:'var(--error)' },
          ].map(s => (
            <div key={s.label} style={{ padding:'14px', borderRadius:'var(--radius-md)', background:'var(--bg-muted)', textAlign:'center' }}>
              <div style={{ fontSize:'22px', fontWeight:800, color:s.color }}>{s.value}</div>
              <div style={{ fontSize:'11.5px', color:'var(--text-muted)', marginTop:'3px' }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{ marginBottom:'14px' }}>
          <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'6px' }}>Count cash in drawer ({sym})</label>
          <input type="number" value={cashCounted} onChange={e => setCashCounted(e.target.value)} placeholder="Enter cash amount..." style={inp} onFocus={inpF} onBlur={inpB} />
          {cashVariance !== null && (
            <div style={{ marginTop:'8px', padding:'10px', borderRadius:'var(--radius-sm)', background: Math.abs(cashVariance) < 1 ? '#F0FDF4' : '#FEF2F2', fontSize:'12.5px', fontWeight:700, color: Math.abs(cashVariance) < 1 ? 'var(--success)' : 'var(--error)' }}>
              Variance: {cashVariance >= 0 ? '+' : ''}{sym}{cashVariance.toFixed(2)}
              {Math.abs(cashVariance) < 1 && ' ✓ Balanced'}
            </div>
          )}
        </div>

        <div style={{ marginBottom:'16px' }}>
          <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'6px' }}>Notes</label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Any notes for the shift..." rows={2} style={{ ...inp, resize:'none' }} onFocus={inpF} onBlur={inpB} />
        </div>

        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={onClose} style={{ flex:1, padding:'12px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Cancel</button>
          <button onClick={() => onShiftComplete({ staff_name: options.staffName, branch: options.branchName, shift_end: new Date().toISOString(), total_sales: todayStats.sales, total_orders: todayStats.orders, total_returns: todayStats.returns, total_voids: todayStats.voids, cash_counted: cashCounted ? Number(cashCounted) : null, variance: cashVariance, notes, payment_breakdown: {} })}
            style={{ flex:2, padding:'12px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>
            Close Shift & Print Report
          </button>
        </div>
      </div>
    </Overlay>
  )
}

// ── GOLD RATE MODAL ───────────────────────────────────────────
function GoldRateModal({ goldRates, sym, onSave, onClose }) {
  const [rates, setRates] = useState({
    rate_22k: goldRates?.rate_22k || '', rate_18k: goldRates?.rate_18k || '',
    rate_14k: goldRates?.rate_14k || '', rate_silver: goldRates?.rate_silver || '',
    rate_platinum: goldRates?.rate_platinum || '',
    buyback_22k: goldRates?.buyback_22k || '', buyback_18k: goldRates?.buyback_18k || '',
    buyback_14k: goldRates?.buyback_14k || '', buyback_silver: goldRates?.buyback_silver || '',
  })
  const setRate = (k, v) => setRates(r => ({ ...r, [k]: v }))

  const metals = [
    { label:'22K Gold',  sell:'rate_22k',     buy:'buyback_22k' },
    { label:'18K Gold',  sell:'rate_18k',     buy:'buyback_18k' },
    { label:'14K Gold',  sell:'rate_14k',     buy:'buyback_14k' },
    { label:'Silver',    sell:'rate_silver',  buy:'buyback_silver' },
    { label:'Platinum',  sell:'rate_platinum', buy:null },
  ]

  return (
    <Overlay onClose={onClose}>
      <ModalHeader title="Update Gold / Metal Rates" onClose={onClose} />
      <div style={{ padding:'16px' }}>
        <div style={{ padding:'8px 12px', borderRadius:'var(--radius-sm)', background:'#FFF8E6', border:'1px solid #FDE68A', fontSize:'12px', color:'var(--warning)', marginBottom:'14px' }}>
          Selling rates used to calculate product prices. Buyback rates used for old gold exchange. Both are customisable and saved until you update again.
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'8px', marginBottom:'8px' }}>
          <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em' }}>Metal</div>
          <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em' }}>Sell ({sym}/g)</div>
          <div style={{ fontSize:'11px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.06em' }}>Buyback ({sym}/g)</div>
        </div>

        {metals.map(m => (
          <div key={m.label} style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'8px', marginBottom:'7px', alignItems:'center' }}>
            <span style={{ fontSize:'12.5px', fontWeight:600, color:'var(--text-primary)' }}>{m.label}</span>
            <input type="number" value={rates[m.sell]} onChange={e => setRate(m.sell, e.target.value)}
              placeholder="0" style={{ ...inp, padding:'6px 8px', fontSize:'12px' }} onFocus={inpF} onBlur={inpB} />
            {m.buy
              ? <input type="number" value={rates[m.buy]} onChange={e => setRate(m.buy, e.target.value)}
                  placeholder="0" style={{ ...inp, padding:'6px 8px', fontSize:'12px' }} onFocus={inpF} onBlur={inpB} />
              : <div style={{ fontSize:'11px', color:'var(--text-muted)' }}>N/A</div>
            }
          </div>
        ))}

        <div style={{ marginTop:'16px', display:'flex', gap:'8px' }}>
          <button onClick={onClose} style={{ flex:1, padding:'11px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Cancel</button>
          <button onClick={() => onSave(rates)} style={{ flex:2, padding:'11px', borderRadius:'var(--radius-md)', border:'none', background:'var(--warning)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>Save Rates</button>
        </div>
      </div>
    </Overlay>
  )
}

// ── CUSTOM ITEM MODAL ─────────────────────────────────────────
function CustomItemModal({ sym, onAdd, onClose }) {
  const [name, setName]   = useState('')
  const [price, setPrice] = useState('')
  const [qty, setQty]     = useState(1)

  return (
    <Overlay onClose={onClose}>
      <ModalHeader title="Add Custom Item" onClose={onClose} />
      <div style={{ padding:'16px', display:'flex', flexDirection:'column', gap:'10px' }}>
        <div>
          <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'5px' }}>Item name *</label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Labour charge, Gift wrap..." style={inp} onFocus={inpF} onBlur={inpB} autoFocus />
        </div>
        <div>
          <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'5px' }}>Price ({sym}) *</label>
          <input type="number" value={price} onChange={e => setPrice(e.target.value)} placeholder="0" style={inp} onFocus={inpF} onBlur={inpB} />
        </div>
        <div>
          <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'5px' }}>Quantity</label>
          <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
            <button onClick={() => setQty(q => Math.max(1, q - 1))} style={{ width:'32px', height:'32px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'16px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
            <span style={{ fontSize:'16px', fontWeight:700, minWidth:'32px', textAlign:'center' }}>{qty}</span>
            <button onClick={() => setQty(q => q + 1)} style={{ width:'32px', height:'32px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'16px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'6px' }}>
          <button onClick={onClose} style={{ flex:1, padding:'11px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Cancel</button>
          <button onClick={() => name && price && onAdd(name, price, qty)} disabled={!name || !price}
            style={{ flex:2, padding:'11px', borderRadius:'var(--radius-md)', border:'none', background: name && price ? 'var(--primary)' : 'var(--border)', color:'#fff', fontSize:'13px', fontWeight:700, cursor: name && price ? 'pointer' : 'not-allowed' }}>
            Add to cart
          </button>
        </div>
      </div>
    </Overlay>
  )
}

// ── HOLD LABEL MODAL ──────────────────────────────────────────
function HoldLabelModal({ onConfirm, onClose }) {
  const [label, setLabel] = useState('')
  return (
    <Overlay onClose={onClose}>
      <ModalHeader title="Hold Order" onClose={onClose} />
      <div style={{ padding:'16px' }}>
        <label style={{ fontSize:'12px', fontWeight:700, color:'var(--text-muted)', display:'block', marginBottom:'6px' }}>Label (optional)</label>
        <input value={label} onChange={e => setLabel(e.target.value)} placeholder="e.g. Table 3, Hamza, Customer 2" style={{ ...inp, marginBottom:'14px' }} onFocus={inpF} onBlur={inpB} autoFocus onKeyDown={e => e.key === 'Enter' && onConfirm(label)} />
        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={onClose} style={{ flex:1, padding:'11px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'13px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>Cancel</button>
          <button onClick={() => onConfirm(label)} style={{ flex:2, padding:'11px', borderRadius:'var(--radius-md)', border:'none', background:'var(--primary)', color:'#fff', fontSize:'13px', fontWeight:700, cursor:'pointer' }}>Hold Order</button>
        </div>
      </div>
    </Overlay>
  )
}

// ── MAIN EXPORT ───────────────────────────────────────────────
export default function POSModals({
  modal, closeModal,
  numpadTarget, numpadValue, setNumpadValue, onNumpadConfirm,
  variantPicker, pickerQty, setPickerQty, pickerNote, setPickerNote, pickerWeight, setPickerWeight, onVariantConfirm,
  receiptOrder, seller, sym, onReceiptClose,
  onHoldConfirm,
  goldRates, onGoldRateSave,
  onCustomItemAdd,
  sellerId, staffSession, onVoidComplete,
  onReturnComplete,
  todayStats, posMode, options, onShiftComplete,
  isJewellery,
}) {
  if (!modal.type) return null

  switch (modal.type) {
    case 'numpad':
      return <NumpadModal target={numpadTarget} value={numpadValue} setValue={setNumpadValue} onConfirm={onNumpadConfirm} onClose={closeModal} sym={sym} />
    case 'variant':
      return <VariantModal variantPicker={variantPicker} pickerQty={pickerQty} setPickerQty={setPickerQty} pickerNote={pickerNote} setPickerNote={setPickerNote} pickerWeight={pickerWeight} setPickerWeight={setPickerWeight} onConfirm={onVariantConfirm} onClose={closeModal} sym={sym} isJewellery={isJewellery} goldRates={goldRates} />
    case 'receipt':
      return <ReceiptModal order={receiptOrder} seller={seller} sym={sym} onClose={onReceiptClose} />
    case 'return':
      return <ReturnModal sellerId={sellerId} sym={sym} onReturnComplete={onReturnComplete} onClose={closeModal} />
    case 'void':
      return <VoidModal sellerId={sellerId} staffSession={staffSession} sym={sym} onVoidComplete={onVoidComplete} onClose={closeModal} />
    case 'shift':
      return <ShiftModal todayStats={todayStats} sym={sym} options={options} onShiftComplete={onShiftComplete} onClose={closeModal} />
    case 'gold_rate':
      return <GoldRateModal goldRates={goldRates} sym={sym} onSave={onGoldRateSave} onClose={closeModal} />
    case 'custom_item':
      return <CustomItemModal sym={sym} onAdd={onCustomItemAdd} onClose={closeModal} />
    case 'hold_label':
      return <HoldLabelModal onConfirm={onHoldConfirm} onClose={closeModal} />
    default:
      return null
  }
}